export const OAuth = {
	AUTH_ENDPOINT: 'https://127.0.0.1/oauth/token',
	USER_ENDPOINT: 'https://127.0.0.1/api/user',
	CLIENT_ID: '2',
	CLIENT_SECRET: 'SVNR3D9ItGSQnTPTjCXt1jOO35XuKkSjB8zXrO3n',
};